


















































































































import { Component, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';
import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import { Spinner } from 'vue-image-spinner2';

@Component({
    name: 'blog-detail-modal',
    components: {
        Spinner,
    },
    computed: {
        ...mapState('blogPosts', ['activeBlogLoading', 'activeBlog']),
        ...mapState('blogPosts', {
            activeBlog: (state: any) => {
                if (state.activeBlog.status == 'published') {
                    state.activeBlog.status = true;
                } else {
                    state.activeBlog.status = false;
                }

                console.log(state.activeBlog.featured_image);
                if (state.activeBlog.featured_image == null || state.activeBlog.featured_image.length == 0) {
                    state.activeBlog.featured_image = '';
                } else {
                    state.activeBlog.featured_image = `https://directus.prodelec.app/assets/${state.activeBlog.featured_image}`;
                }

                return {
                    ...state.activeBlog,
                };
            },
        }),
    },
})
export default class BlogDetailModal extends Vue {
    //
    private activeBlog!: any;
    private activeBlogLoading!: any;

    private searchQuery: string = '';
    public dataPdf: any = '';
    public pdfSrc: string = '';
    public products_blog: any = [];
    public fields_product_blog: any = ['qty', 'price'];
    // public intelisis_movement: string = '';

    get permalink() {
        return `https://www.mercadolibre.com.mx/ventas/${this.activeBlog.id}/detalle`;
    }

    getBlogUrl(id: string) {
        return `https://prodelec.mx/wp-admin/post.php?post=${id}&action=edit&classic-editor`;
    }

    onSaveBlog() {
        let vm = this;
        this.activeBlog.status ? (this.activeBlog.status = 'published') : (this.activeBlog.status = 'draft');
        let blogData = this.activeBlog;
        this.$store.dispatch('blogPosts/postOne', { vm, blogData });
    }

    onFileChange(e) {
        const files = e.target.files;
        let filesContainer = [];
        let filesData = [];
        files.forEach((file) => {
            let formData = new FormData();
            formData.append('image', file, file.name);
            this.activeBlog.featured_image = [
                {
                    id: uuidv4(),
                    sort: null,
                    url: URL.createObjectURL(file),
                    origin: 'upload',
                    file: formData,
                },
            ];
        });
    }

    onRemoveImg() {
        this.activeBlog.featured_image = '';
        console.log('removed', this.activeBlog);
    }

    onShowBlog() {
        console.log('this.activeBlog ==> ', this.activeBlog);
    }
}
